import React, { Suspense, useMemo } from "react";
import { useGLTF } from "@react-three/drei";

const ThreeB = (props) => {
  // GLTF
  const gltf = useGLTF("./three-2.glb");
  const copiedScene = useMemo(() => gltf.scene.clone(), [gltf.scene]);

  return (
    <Suspense fallback={null}>
      <primitive {...props} object={copiedScene} />
    </Suspense>
  );
};

useGLTF.preload("./three-2.glb");

export default ThreeB;
